// inject app sagas
import userSaga from 'store/user/rootSaga';
import contractSagas from 'store/contract/rootSaga';
import credentialsSagas from 'store/credentials/saga';
import globalSaga from 'store/global/saga';
import sinistreSaga from 'store/sinistre/saga';
import geolocAgentSaga from 'store/geolocAgent/saga';
import localeSaga from 'store/LanguageProvider/saga';
import pacSaga from 'store/pac/saga';
import organizationsSaga from 'store/organizations/saga';
import doctorsSaga from 'store/doctors/saga';
import policies from 'store/policies/saga';

export default [
  ...userSaga,
  ...contractSagas,
  ...credentialsSagas,
  ...globalSaga,
  ...sinistreSaga,
  ...geolocAgentSaga,
  ...localeSaga,
  ...pacSaga,
  ...organizationsSaga,
  ...doctorsSaga,
  ...policies,
];
